import React from "react";
import PropTypes from "prop-types";
import { getLensDisplayColor } from "../../../utils/colorUtils";

/**
 * Lens color display component
 * Shows a color swatch with color name for lens selections
 *
 * @component
 * @param {Object} props
 * @param {string|Object} props.color - Color string or color object
 */
const LensColorDisplay = ({ color }) => {
  if (!color) return null;

  const colorName = typeof color === "string" ? color : color.name || color.displayName;
  const cssColor = getLensDisplayColor(color);

  const swatchStyle = {
    backgroundColor: cssColor,
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "5px",
    border: "1px solid #666",
    verticalAlign: "text-top",
    position: "relative",
    top: "1px",
  };

  return (
    <div className="item-lens-color">
      <span className="color-swatch-tiny" style={swatchStyle} />
      <span className="color-name">{colorName}</span>
    </div>
  );
};

LensColorDisplay.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default LensColorDisplay;
